import { PaymentElement } from '@stripe/react-stripe-js';
import { StripePaymentElementChangeEvent } from '@stripe/stripe-js';
import { CardFormWrapper } from './PaymentForm.style';
import { PaymentFormV2Props } from './PaymentFormV2.types';

export const PaymentFormV2: React.FC<PaymentFormV2Props> = ({ onChange, userEmail, userName }) => {
  const onStripeFormChange = (event: StripePaymentElementChangeEvent) => {
    onChange({
      completed: event.complete,
      paymentMethod: event.value.type,
    });
  };

  return (
    <CardFormWrapper>
      <PaymentElement
        options={{
          layout: 'tabs',
          defaultValues: {
            billingDetails: {
              email: userEmail && userEmail.length > 0 ? userEmail : '',
              name: userName && userName.length > 0 ? userName : '',
            },
          },
        }}
        onChange={onStripeFormChange}
      />
    </CardFormWrapper>
  );
};
